import { IconButton, Menu, MenuItem } from "@mui/material";
import React, { useContext, useState } from "react";
import { connect } from "react-redux";
import { selectProject, selectUserId } from "../../redux/selectors/editor";
import { selectUser } from "../../redux/selectors/firebase";
import { FirebaseContext } from "../firebase/FirebaseProvider";
import { getAuth, signOut } from "firebase/auth";
import UserAvatar from "./UserAvatar";
import { PathwayUser } from "../../redux/types/firebase";
import { updateMode } from "../../redux/slices/editor";

interface Props
{
    userId: string
    user: PathwayUser
    onCloseProject: () => void
    onShowDialog: (dialog: string) => void
    updateMode: (mode: string) => void
    project: string
}
function UserMenu({ user, project,
    onCloseProject, onShowDialog, updateMode }: Props)
{
    const { untrackUser } = useContext(FirebaseContext);

    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) =>
    {
        setAnchorEl(event.currentTarget);
    }

    const handleClose = () =>
    {
        setAnchorEl(null);
    }

    const handleSignOutClick = () =>
    {
        const auth = getAuth();

        handleClose();
        onCloseProject();
        untrackUser(auth.currentUser?.uid as string);
        signOut(auth);
    }

    const handleUserDetailsClick = () =>
    {
        handleClose();
        onShowDialog("user");
    }

    const handleAdminToolsClick = () =>
    {
        handleClose();
        updateMode("admin");
    }

    const admin = user.roles.admin;

    return <>
        <IconButton onClick={handleClick}>
            <UserAvatar />
        </IconButton>
        <Menu open={open} anchorEl={anchorEl} onClose={handleClose}>
            {admin && project &&
                <MenuItem onClick={handleAdminToolsClick}>Admin Tools</MenuItem>
            }
            <MenuItem onClick={handleUserDetailsClick}>User Details</MenuItem>
            <MenuItem onClick={handleSignOutClick}>Sign Out</MenuItem>
        </Menu>
    </>
}

const mapStateToProps = (store: never) => ({
    userId: selectUserId(store),
    user: selectUser(store),
    project: selectProject(store)
});
export default connect(mapStateToProps, {
    updateMode
})(UserMenu);